import React, { useEffect, useState } from "react";
import "./Episodes.css";
import { useParams } from "react-router-dom";
import JwPlayerMultiLanguage from "../Players/EpisodesDetailPlayer/JwPlayerMultiLanguage";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";

export const StudentAdminTrailerDetail = () => {
  const { questId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiImgurl = process.env.REACT_APP_IMG_URL;
  const { student, fetchWithAuthStudent } = useAuthStudent(); // Fetch student details from AuthContext

  const [trailer, setTrailer] = useState(null); // Initial state is null
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const fetchChapterData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest/${questId}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch trailer");
        }

        const data = await response.json();

        setTrailer(data);
        setLoading(false); // Mark loading as false when data is fetched
      } catch (error) {
        setLoading(false); // Stop loading even on error
      }
    };

    // const intervalId = setInterval(fetchChapterData, 10000); // Refresh every 10 seconds
    fetchChapterData();

    // return () => clearInterval(intervalId); // Cleanup
  }, [apiUrl, student, questId, fetchWithAuthStudent]);

  const videoSources = {
    en:
      trailer?.trailerType === "jwplayer"
        ? `https://cdn.jwplayer.com/manifests/${trailer?.trailerEngJwp}.m3u8`
        : `${apiImgurl}/code/public/storage/${trailer?.trailerEng}`, // Use the fetched video for English
    hi:
      trailer?.trailerType === "jwplayer"
        ? `https://cdn.jwplayer.com/manifests/${trailer?.trailerHinJwp}.m3u8`
        : `${apiImgurl}/code/public/storage/${trailer?.trailerHin}`, // Use the fetched video for Hindi
  };

  return (
    <div className="container-fluid p-0">
      {!loading ? (
        <JwPlayerMultiLanguage questId={questId} videoSources={videoSources} />
      ) : (
        // Add a loading placeholder for the video
        <div className="video-placeholder">
          <p>Loading video...</p>
        </div>
      )}
    </div>
  );
};
